import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/subject/subjectClasses/editSubjectClassContainer';
import { actions } from '../../../redux/subject/subjectClasses';
import { actions as studentActions } from '../../../redux/user/students';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
    dispatch(studentActions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
